import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import { GroupsOfficeService } from "../../../../services/group365/groupOffice.service";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import List from "devextreme-react/list";

const AddUserModal = (props: any) => {
  const { onClose, isOpen, onSaveComplete, data, member } = props;
  const [selectedUsers, setSelectedUsers] = useState<any>([]);

  const handleOnSubmit = async () => {
    onClose();
  };

  const addUser = async () => {
    let memberId: any = null;
    if (selectedUsers.length > 1) {
      memberId = selectedUsers.map((e: any) => "https://graph.microsoft.com/v1.0/directoryObjects/" + e.id);
      const fields = {
        "members@odata.bind": memberId,
      };
      const result = GroupsOfficeService.addMultipleMember(data.id, fields);
      onSaveComplete(result);
    } else {
      const fields = {
        "@odata.id": "https://graph.microsoft.com/beta/directoryObjects/" + selectedUsers[0].id,
      };
      const result = GroupsOfficeService.addMember(data.id, fields);
      onSaveComplete(result);
    }
    onClose();
  };

  const handleSectionChange = (user: any) => {
    setSelectedUsers(user.target.selectedPeople);
  };

  const handleItemDeleting = async (value: any) => {
    await GroupsOfficeService.removeMember(data.id, value.itemData.id);
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered className="edit-department-detail-modal">
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={{
          id: data?.id || "",
          name: data?.displayName || "",
          description: data?.description || "",
          emailGroup: data?.mailNickname || null,
        }}
      >
        {({ errors }) => (
          <Form noValidate>
            <Modal.Header closeButton>
              <Modal.Title>Thêm thành viên</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              <Form.Group as={Row} controlId="validationCustom01">
                <Form.Label column sm={3} className="card-label">
                  Thành viên
                </Form.Label>
                <Col sm={9}>
                  <div className="people_picker-custom">
                    <PeoplePicker
                      className="people-picker"
                      type={PersonType.any}
                      selectionChanged={handleSectionChange}
                    />
                  </div>
                </Col>
                <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={9} className="card-label"></Form.Label>
                <Col sm={3}>
                  <Button className="px-4 w-100" variant="success" onClick={addUser}>
                    Thêm
                  </Button>
                </Col>
                <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label column sm={12} className="card-label">
                  Thành viên hiện tại
                </Form.Label>
                <Col sm={12}>
                  <List
                    dataSource={member}
                    displayExpr="displayName"
                    height={200}
                    allowItemDeleting={true}
                    onItemDeleting={handleItemDeleting}
                    itemDeleteMode="toggle"
                  ></List>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="px-3">
              <Button className="px-4" onClick={onClose} variant="secondary">
                Đóng
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddUserModal;
